import { MinusCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';
import InputWithLabel from '../common/InputWithLabel';
import TextareaWithLabel from '../common/TextareaWithLabel';
import Icons from '../svgs/icons';
import { capitalizeFirstLetter } from '../../utils/helper';
import { TutorialsPageData as mainPageData } from '../../utils/pageContent';

const FaqForm = ({ index, data, onChange, onRemove, disabled, error1, error2, title, questionPlaceholder, answerPlaceholder }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange?.(name, capitalizeFirstLetter(value));
  };
  const sectionData = mainPageData.editTutorialPageData.tutorialInfoSection.faqFormSection;
  return (
    <div className="max-w-[534px] w-full space-y-4">
      <div className="flex gap-4 items-start">
        <div className="flex gap-4 items-center">
          {!disabled && (
            <button className="shrink-0" disabled={disabled} onClick={onRemove}>
              <Icons.minusCircle className="w-6 h-6 text-[#A1A1A1]" />
            </button>
          )}
          <div className="ml-1 border-[1.5px] shrink-0 border-shoorah-borderGray dark:border-transparent bg-shoorah-normanGray dark:bg-shoorah-darkBgColor rounded-[8px] px-[10px] py-2 text-sm font-medium">
            {title ? title : sectionData.faqTitleLabel} {index + 1}
          </div>
        </div>
        <div>
          <InputWithLabel
            placeholder={questionPlaceholder ? questionPlaceholder : sectionData.faqQuestionPlaceholder}
            containerClassName={'w-full'}
            name={sectionData.faqQuestionLabel}
            value={data.faqQuestion}
            onChange={handleChange}
            disabled={disabled}
          />
          {error1 && <p className="text-red-500 text-sm mt-2">{error1}</p>}
        </div>
      </div>
      <TextareaWithLabel
        name={sectionData.faqAnswerLabel}
        className={' min-h-[74px]'}
        onChange={handleChange}
        value={data.faqAnswer}
        placeholder={answerPlaceholder ? answerPlaceholder : sectionData.faqAnswerPlaceholer}
        disabled={disabled}
      />
      {error2 && <p className="text-red-500 text-sm !mt-2">{error2}</p>}
    </div>
  );
};

export default FaqForm;
